import reducer from './reducers'

export * from './actions'

export default reducer
